import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TravelInsuranceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none">
        <path
          d="M11.39 39.553c7.839 5.56 18.7 3.712 24.26-4.126 5.559-7.839 3.711-18.7-4.127-24.26-7.839-5.558-18.7-3.71-24.26 4.127-5.558 7.839-3.71 18.7 4.127 24.26z"
          fill="#ffffff"
          className={classnames(styles.white, styles.defaultStrokeColor)}
          stroke="#000000"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M20.818 8.112s-.407 3.512.027 4.8c.435 1.29-.18 1.466-1.851 2.61-1.612 1.064-1.773 1.809-2.667 2.032-.813.282-.744-.16-1.241.714-.497.873-1.215 1.713-1.276.934s.055-.942-1.118-.67c-1.173.27-1.313.294-2.089 1.215-.775.921-1.717.866-1.157 1.632.619.683 1.395-.237 1.295 1.286s.182 2.336.474 2.788c.293.453 1.587 1.739 2.121 1.504.534-.234 2.102-.716 3.686.162s1.155 1.31 2.263 2.34c1.165.95.992 1.195 2.681 2.27 1.69 1.076 2.855 2.025 2.497 2.875-.357.85-1.83 1.89-2.024 2.855-.195.965-.253 1.047-1.1 1.55-.823.642-1.201 2.212-1.722 2.947-.578.815-1.439.818-2.638.09-1.503-.82-.95-2.636-1.711-4.156s-2.185-3.143-2.722-3.77c-.479-.707-.886-.996-.73-2.6.298-1.63.77-2.642.618-3.118s-.166-.976-1.355-2.065c-1.108-1.03-1.074-1.252-1.577-2.099s-.792-.439-1.539-1.46.144-2.104-.393-2.73-.815-.578-.134-2.057-.196-2.836-.196-2.836 4.21-6.454 13.578-7.043m13.681 6.638s.308 1.812.648 2.544c.34.73-.484 1.373-.654 2.478s-.145 2.105.16 3.057c.46 1.428 1.275 2.007 1.601 2.238 1.655 1.296 2.2.702 2.2.702s.79-7.164-3.955-11.019"
          fill="#E81C30"
          className={styles.accentColor}
        />
        <path
          d="M11.39 39.553c7.839 5.56 18.7 3.712 24.26-4.126 5.559-7.839 3.711-18.7-4.127-24.26-7.839-5.558-18.7-3.71-24.26 4.127-5.558 7.839-3.71 18.7 4.127 24.26z"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M25.326 45.835c-.314.038-.53.095-.844.133m-3.197.161c-1.314-.066-2.628-.13-3.901-.392-11.266-2.31-18.606-13.31-16.295-24.575 1.145-5.584 4.443-10.215 8.81-13.097 3.799-2.59 8.453-3.88 13.255-3.406m1.706.146l.783.16"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeDasharray="2 3"
          strokeLinecap="round"
          strokeMiterlimit="10"
        />
        <path
          clipRule="evenodd"
          d="M46.5 49.125H33.375c-1.25 0-2.375-1-2.375-2.375V27.375C31 26 32 25 33.375 25h13.25C47.875 25 49 26 49 27.375V46.75c-.125 1.375-1.125 2.375-2.5 2.375"
          fill="#ffffff"
          className={styles.white}
          fillRule="evenodd"
        />
        <path
          d="M46.5 49.125H33.375c-1.25 0-2.375-1-2.375-2.375V27.375C31 26 32 25 33.375 25h13.25C47.875 25 49 26 49 27.375V46.75c-.125 1.375-1.125 2.375-2.5 2.375"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M34.125 29.625h5.75m-5.75 2.75h11.5M34.25 34.75h11.5m-11.5 2.75h11.5"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeWidth="0.75"
        />
        <path
          clipRule="evenodd"
          d="M44.418 40.215l-6.544 5.876-3.043-2.753.839-.927 2.207 1.997 5.706-5.123z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
}
